import { Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { HttpService } from './http.service';

@Injectable()
export class UserService {

    // Observable: EntChange Success
    userEntChanged$ = new Subject<boolean>();
    component$ = new Subject<string>();

    constructor(
        private http: HttpService
    ) { }

    getUserEntList() {
        return this.http.get('api/srm/ent/list', {})
            .map(res => {
                const result = {
                    listdata: [],
                    value: ''
                };
                if (res && res['head'] && res['head'].status === 1) {
                    if (res['body'] && res['body'].resultList) {
                        result.listdata = res['body'].resultList.listdata || [];
                        result.value = res['body'].currentEnt;
                    }
                }
                return result;
            });
        // return this._http.get<Array<any>>('/assets/mock/userEntList.json');
    }

    updateUserEnt(value) {
        return this.http.post('api/srm/ent/change', { ent: value })
            .map(res => (res && res['head'] && res['head'].status === 1))
            .do(res => { this.userEntChanged$.next(!!res); });
    }

    getSiteByEnt() {
        return this.http.post('api/srm/paddress/getSiteByEnt', {})
            .switchMap(res => this.http.mapRes(res));
    }

    getOrderTypeList() {
        return this.http.get('api/srm/purchase/purchaseType', {})
            .switchMap(res => this.http.mapRes(res));
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/services/user.service.ts